import React, { useContext } from 'react'
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button
} from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import DashboardIcon from '@mui/icons-material/Dashboard'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import KitchenIcon from '@mui/icons-material/Kitchen'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import NotificationsIcon from '@mui/icons-material/Notifications'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import LogoutIcon from '@mui/icons-material/Logout'
import { AccountContext } from 'contexts/AccountContext'

const Navbar = () => {
  const location = useLocation()
  const { logout, isAuthenticated } = useContext(AccountContext)

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/'
    }
    return location.pathname.startsWith(path)
  }

  type MenuItem = {
    text: string
    icon: React.ReactNode
    path: string
    isLink: true
  }

  const menuItems: MenuItem[] = [
    {
      text: 'Dashboard',
      icon: <DashboardIcon />,
      path: '/',
      isLink: true
    },
    {
      text: 'Manage Accounts',
      icon: <PeopleAltIcon />,
      path: '/accounts',
      isLink: true
    },
    {
      text: 'Products',
      icon: <KitchenIcon />,
      path: '/products',
      isLink: true
    },
    {
      text: 'Tasks',
      icon: <AssignmentTurnedInIcon />,
      path: '/tasks',
      isLink: true
    },
    {
      text: 'Orders',
      icon: <ShoppingCartIcon />,
      path: '/orders',
      isLink: true
    },
    {
      text: 'Notification Settings',
      icon: <NotificationsIcon />,
      path: '/notification-settings',
      isLink: true
    },
    {
      text: 'Admin Management',
      icon: <AdminPanelSettingsIcon />,
      path: '/admin-management',
      isLink: true
    }
  ]

  return (
    <>
      <Drawer
        variant='permanent'
        sx={{
          width: 240,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: 240,
            boxSizing: 'border-box',
            bgcolor: 'primary.main',
            color: 'white'
          }
        }}
      >
        <Box
          sx={{
            p: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Box
            component='img'
            src='/woodland-logo-light.png'
            alt='logo'
            sx={{ width: 140, height: 'auto' }}
          />
        </Box>

        <List sx={{ flexGrow: 1, pt: 2 }}>
          {menuItems.map(item => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton
                component={Link}
                to={item.path}
                selected={isActive(item.path)}
                sx={{
                  color: 'inherit',
                  '&.Mui-selected': {
                    bgcolor: 'transparent',
                    fontWeight: 'bold',
                    '& .MuiListItemText-primary': {
                      fontWeight: 'bold'
                    },
                    '&:hover': {
                      bgcolor: 'rgba(255, 255, 255, 0.08)'
                    }
                  },
                  '&:hover': {
                    bgcolor: 'rgba(255, 255, 255, 0.08)'
                  }
                }}
              >
                <ListItemIcon sx={{ color: 'inherit', minWidth: 40 }}>
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        {isAuthenticated && (
          <Box sx={{ p: 2 }}>
            <Button
              fullWidth
              variant='outlined'
              startIcon={<LogoutIcon />}
              onClick={() => logout()}
              sx={{
                color: 'white',
                borderColor: 'rgba(255, 255, 255, 0.5)',
                '&:hover': {
                  borderColor: 'white',
                  bgcolor: 'rgba(255, 255, 255, 0.08)'
                }
              }}
            >
              Logout
            </Button>
          </Box>
        )}
      </Drawer>
    </>
  )
}

export default Navbar
